export enum MachineMenuItems{
  DATA_CONFIG = 'data-config',
  STATUS = 'status',
  TRAFFIC_LIGHT = 'traffic-light',
  PUB_SUB = 'pub-sub',
  TRIGGER_ACTION = 'trigger-action',
  TRIGGER_CONFIGURATION = 'trigger-configuration',
  API_CONFIG = 'api-config',
  METADATA = 'metadata'
}
